import { addParamsToPath, routes } from '@app/constants/route.constants';
import { Product } from '@app/types/enums';

export const productRedirects = [
  {
    deprecatedProductName: 'fastrenteinnskudd',
    replacementProductUrl: addParamsToPath(routes.LoginPage, { product: Product.FIXED_DEPOSIT_6_MONTHS }),
  },
];
